import { LinesWorkInfo } from "./LinesWorkInfo";

export const LinesWorkInfoRoute = () => {
  return (
    <LinesWorkInfo />
  )
}